import Box from '@mui/material/Box';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { t } from 'i18next';
import { useState } from 'react';

import Dialog from '~components/Dialog/Dialog';
import DialogActions from '~components/Dialog/DialogActions';
import DialogContent from '~components/Dialog/DialogContent';
import DialogHeader from '~components/Dialog/DialogHeader';
import { SmallButton } from '~components/Order/ordersDispatchStyledComponents';

import { JobCardPdfRecipientType } from './models';

interface JobCardPdfTypeDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (type: JobCardPdfRecipientType) => void;
}

export default function JobCardPdfTypeDialog({
  isOpen,
  onClose,
  onSelect,
}: JobCardPdfTypeDialogProps) {
  const [selected, setSelected] = useState<JobCardPdfRecipientType>('customer');

  const handleClose = () => {
    setSelected('customer');
    onClose();
  };

  const handleSubmit = () => {
    onSelect(selected);
    setSelected('customer');
  };

  return (
    <Box onClick={(event) => event.stopPropagation()}>
      <Dialog isOpen={isOpen} maxWidth="sm" onClose={handleClose}>
        <DialogHeader onClose={handleClose}>
          {t('dispatch.job_card.pdf_type_dialog_title')}
        </DialogHeader>

        <DialogContent>
          <RadioGroup
            value={selected}
            onChange={(event) =>
              setSelected(event.target.value as JobCardPdfRecipientType)
            }
          >
            <FormControlLabel
              control={<Radio />}
              label={t('dispatch.job_card.customer')}
              value="customer"
            />
            <FormControlLabel
              control={<Radio />}
              label={t('dispatch.job_card.vendor_driver')}
              value="vendor_driver"
            />
          </RadioGroup>
        </DialogContent>

        <DialogActions>
          <SmallButton color="secondary" onClick={handleClose} variant="outlined">
            {t('actions.cancel')}
          </SmallButton>

          <SmallButton color="brandV2Yellow" onClick={handleSubmit} variant="contained">
            {t('dispatch.job_card.download')}
          </SmallButton>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
